module.exports = __webpack_public_path__ + "img/value.d7744761.png";